import { Component } from '@angular/core';
import { Platform, NavController } from '@ionic/angular';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { environment, SERVER_URL } from '../environments/environment'
import { NetworkService } from './service/network/network.service';
import { CommonDeclarationService } from './service/common/common-declaration.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  appDetails: any;
  showmanintance : boolean = false;
  maintancemsg: any;
  currentPage: any;
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'List',
      url: '/list',
      icon: 'list'
    }
  ];

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    public api: RestapiService,
    private router: Router,
    public cmndef: CommonDefinitionService,
    public cmndec: CommonDeclarationService,
    public network: NetworkService,
    public navCtrl: NavController
  ) {
    this.platform.ready().then(() => {
      this.initializeApp();
      // document.addEventListener('backbutton', () => {
      //   console.log("back button pressed");
      //   // console.log(this.app);
      //   if ((!this.cmndec.loaderenable) && this.cmndef.alertrestiction && (!this.cmndec.Actionsheetenable)) {
      //   console.log(this.router.url);
      //     this.currentPage = sessionStorage.CurrentPage;
      //     if (this.router.url == "/va/chat") {
      //       if (localStorage.role != "new")
      //         this.cmndef.showConfirmAlert("", this.cmndec.LanguageJson.pages[0].alerts.exitMessage, "exit", this.cmndec.LanguageJson.pages[0].alerts.yes, this.cmndec.LanguageJson.pages[0].alerts.no)
      //       else
      //         this.cmndef.showConfirmAlert("", this.cmndec.LanguageJson.pages[0].alerts.exitMessage, "close", this.cmndec.LanguageJson.pages[0].alerts.yes, this.cmndec.LanguageJson.pages[0].alerts.no)
      //     } else if(this.router.url == "/freezescreen"){
      //       this.cmndef.showConfirmAlert("", this.cmndec.LanguageJson.pages[0].alerts.exitMessage, "close", this.cmndec.LanguageJson.pages[0].alerts.yes, this.cmndec.LanguageJson.pages[0].alerts.no)
      //     } else if (this.router.url == "/preRegister") {
      //       this.cmndef.showConfirmAlert("", this.cmndec.LanguageJson.pages[0].alerts.exitMessage, "close", this.cmndec.LanguageJson.pages[0].alerts.yes, this.cmndec.LanguageJson.pages[0].alerts.no)
      //     } else if (this.cmndef.TrakcerForm.indexOf(this.router.url) != -1) {
      //       this.api.clickenventcap("back_" + this.cmndef.TrakcerFromValue[this.router.url]);
      //     }
      //     if (this.router.url == "/verifyOtpPassword") {
      //       this.cmndec.functionCall = 'otpback'
      //       sessionStorage.CurrentPage = this.cmndef.Backtowhere[this.currentPage];
      //       this.navCtrl.navigateRoot(this.cmndef.Backtowhere[this.currentPage])
      //     } else if (this.cmndef.Backtowhere[this.currentPage] == "/va/chat") {
      //       this.cmndec.functionCall = "talkback";
      //       sessionStorage.CurrentPage = this.cmndef.Backtowhere[this.currentPage];
      //       this.navCtrl.navigateRoot(this.cmndef.Backtowhere[this.currentPage])
      //     } else {
      //       if (this.cmndef.Backtowhere.hasOwnProperty(this.currentPage)) {
      //         sessionStorage.CurrentPage = this.cmndef.Backtowhere[this.currentPage];
      //         this.navCtrl.navigateBack(this.cmndef.Backtowhere[this.currentPage])
      //       }
      //     }
      //   }
      // }, false);
      // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

      // this.toggleDarkTheme(prefersDark.matches);

      // // Listen for changes to the prefers-color-scheme media query
      // prefersDark.addListener((mediaQuery) => this.toggleDarkTheme(mediaQuery.matches));

      // Add or remove the "dark" class based on if the media query matches
      
      // this.initializeApp();
    })
  }

  toggleDarkTheme(shouldAdd) {
    document.body.classList.toggle('dark', shouldAdd);
  }

  initializeApp() {
    // this.getOnLaunchConfig();
    sessionStorage.CurrentPage = "/va/chat"
    this.navCtrl.navigateRoot("/va/chat");
          return false;
    if (this.cmndec.BrowserBuild != 1) {
    if (localStorage.tourstatus == "Visited") {
      if (localStorage.logined != null && localStorage.logined != undefined && !(localStorage.freezetime)) {
        // this.getOnLaunchConfig();
        sessionStorage.CurrentPage = "/loginva"
        this.navCtrl.navigateRoot("/loginva")
      }
      else {
        if (localStorage.role == "" || localStorage.role == undefined || localStorage.role != "new") {
          // this.getOnLaunchConfig();
          if (localStorage.freezetime) {
            sessionStorage.CurrentPage = "/freezescreen"
            this.navCtrl.navigateRoot("/freezescreen")
          }
          else {
            localStorage.removeItem("user");
            localStorage.removeItem("dobdate");
            localStorage.removeItem("logined");
            localStorage.removeItem("role");
            localStorage.removeItem("dob");
            localStorage.removeItem("state");
            this.cmndec.deleteProcess("profile");
            localStorage.removeItem("logout");
            localStorage.removeItem("uniqueId");
            localStorage.removeItem("userChatSessionId");
            localStorage.removeItem("userSessionID");
            sessionStorage.CurrentPage = "/preRegister"
            this.navCtrl.navigateRoot("/preRegister")
          }
        }
        else {
          // this.getOnLaunchConfig();
          sessionStorage.CurrentPage = "/va/chat"
          this.navCtrl.navigateRoot("/va/chat");
        }
      }
    } else {
      sessionStorage.CurrentPage = "/language";
      // this.getOnLaunchConfig();
      this.navCtrl.navigateRoot("/language");
    }
    }
    // adding removing the back button in browser
    // this.getOnLaunchConfig();
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };

    this.statusBar.overlaysWebView(true);
    this.statusBar.overlaysWebView(false);
    this.statusBar.backgroundColorByHexString("#808080");
    // this.splashScreen.hide();
  }

  // async getOnLaunchConfig() {
  //   var data = {};
  //   await this.api.postapi('getOnLaunchConfig', data).then(res => {
  //     this.appDetails = res;
  //     this.cmndec.storeProcess(this.appDetails.Grammar, 'Grammer');
  //     this.cmndec.storeProcess(this.appDetails.NomineeSalutationWithGen, 'nomineeSaluation');
  //     this.cmndec.storeProcess(this.appDetails.NominineeCountry, 'nomineeCountry');
  //     this.cmndec.storeProcess(this.appDetails.NominineeRelationWithGen, 'nomineeRelation');
  //     this.cmndec.storeProcess(this.appDetails.NomineeNationality, 'nomineeNationality');
  //     this.cmndec.storeProcess(this.appDetails.NomineeSalutationWithGen, 'nomineesalgen');
  //     this.cmndec.storeProcess(this.appDetails.NominineeRelationWithGen, 'nomineerelationgen');

  //   //   this.cmndec.getstoreProcess("allnotifications").then(data => {
  //   //       if (data == undefined || data == null || data == "") {
  //   //         var newjson = [{
  //   //           "notistartdate": this.appDetails.StartDate,
  //   //           "notimessage": this.appDetails.NotiMessage
  //   //         }];
  //   //         this.cmndec.storeProcess(newjson, "allnotifications");
  //   //         console.log(this.cmndec.getstoreProcess("allnotifications"));
  //   //       } else {
  //   //         this.cmndef.notificationNumber = "1";
  //   //         console.log("exists");
  //   //         this.cmndec.getstoreProcess("allnotifications").then(data => {
  //   //           var newdata: any = Array();
  //   //           newdata = data
  //   //           for(var i=0;i<newdata.length;i++) {
  //   //             if(newdata[i].notimessage != this.appDetails.NotiMessage) {
  //   //               var createjson = {
  //   //                 "notistartdate": this.appDetails.StartDate,
  //   //                 "notimessage": this.appDetails.NotiMessage
  //   //               };
  //   //               newdata.unshift(createjson);
  //   //               this.cmndec.storeProcess(newdata, "allnotifications");
  //   //             }
  //   //           }
  //   //         });


  //   //       }
  //   // });


  //     localStorage.imgsize = this.appDetails.ImageSizecap;
      
  //     if(this.appDetails.ImageQuality != undefined && this.appDetails.ImageQuality != '' && this.appDetails.ImageQuality != 'null')
  //       localStorage.imagequality = this.appDetails.ImageQuality;
  //     else
  //       localStorage.imagequality = 70;

  //     this.cmndef.greetingupdate = this.appDetails.greetingUpdate;

  //     if (this.cmndec.BrowserBuild != 1) {
  //       if (this.platform.is('android')) {
  //         this.cmndef.greetingmessage = this.appDetails.greetingMessage;
  //       } else if (this.platform.is('ios')) {
  //         this.cmndef.greetingmessage = this.appDetails.iosGreetingMessage;
  //       }
  //     }

  //     if (this.appDetails.AppVersion != null || this.appDetails.AppVersion != "") {
  //       var updateV = parseInt(this.appDetails.AppVersion.replace(/\./g, '')),
  //         betaV = parseInt(this.appDetails.betaVersion.replace(/\./g, '')),
  //         currentV = parseInt(this.cmndec.versionNo.replace(/\./g, ''));

  //       this.cmndef.updateV = updateV;
  //       this.cmndef.currentV = currentV;
  //       this.cmndef.betaV = betaV;
  //       this.cmndef.MaintenanceRequired = this.appDetails.MaintenanceRequired;

  //       console.log(this.appDetails);
  //       if(this.cmndec.BrowserBuild != 1){
  //         if (this.platform.is('android')) {
  //           if(this.appDetails.androidIsActive != '0' && this.appDetails.androidIsActive != '' && this.appDetails.androidIsActive != null){
  //             console.log(this.cmndef.currentV);
  //             let verslist = this.appDetails.androidIsActive.split(',');
  //             console.log(verslist)
  //             for(let i=0;i<verslist.length;i++){
  //               let maintancever = parseInt(verslist[i].replace(/\./g, ''));
  //               if(currentV == maintancever){
  //                 this.showmanintance = true;
  //                 this.maintancemsg = this.appDetails.MaintenanceMessage;
  //                 break;
  //               }
  //             }
  //           }
  //         }else{
  //           if(this.appDetails.iOSIsActive != '0' && this.appDetails.iOSIsActive != '' && this.appDetails.iOSIsActive != null){
  //             console.log(this.cmndef.currentV);
  //             let verslist = this.appDetails.iOSIsActive.split(',');
  //             for(let i=0;i<verslist.length;i++){
  //               let maintancever =parseInt(verslist[i].replace(/\./g, ''));
  //               if(currentV == maintancever){
  //                 this.showmanintance = true;
  //                 this.maintancemsg = this.appDetails.MaintenanceMessage;
  //                 break;
  //               }
  //             }
  //           }
  //         }
  //       }else{
  //         if(this.appDetails.browserIsActive != '0' && this.appDetails.browserIsActive != '' && this.appDetails.browserIsActive != null){
  //           sessionStorage.CurrentPage='/pagenotfound';
  //           this.navCtrl.navigateRoot("/pagenotfound");
  //         }
  //       }
  //     }

  //   },
  //     function (error) {
  //       console.log(error)

  //     });

  // }

  MaintenancePopup(data) {
    if (this.cmndec.BrowserBuild == 1)
      window.location.href = "../../assets/js/servicedownpage.html";
    else
      this.cmndef.presentAlert(data.MaintanenceTitle, data.MaintenanceMessage, "Maintenance");
  }
}
